export default __webpack_public_path__ + "static/media/spinning-arrows.240319bf.gif";